/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { CountryDto } from './countryDto';

export interface UserDto {
  /** User ID */
  id: string;
  /** User Azure ID */
  azureId: string;
  /** Email address of the user */
  email?: string;
  /** First name of the user */
  firstName?: string;
  /** Last name of the user */
  lastName?: string;
  /** Role of the user */
  role: string;
  /** Organization of the user */
  organization: string;
  /** Country information */
  country?: CountryDto;
  /** Created on Azure from back office */
  createdOnAzureFromBack?: boolean;
  /** Creation date */
  createdAt: string;
  /** Last update date */
  updatedAt: string;
}
